export default "__VITE_ASSET__BoRoieYQ__"